'use client';

/**
 * Tiny, unobtrusive version label. Reads the build-stamped
 * NEXT_PUBLIC_APP_VERSION (the same value GET /api/version returns and that's
 * baked into every image as an OCI label). Shows the clean SemVer; the full
 * `<semver>+g<sha>` is in the tooltip for precise build identification.
 */
export function AppVersionBadge({ className = '' }: { className?: string }) {
  const full = process.env.NEXT_PUBLIC_APP_VERSION || 'dev';
  const semver = full.split('+')[0].replace(/^v/, '');
  return (
    <span
      data-testid="app-version-badge"
      title={`${full} · GET /api/version`}
      className={`select-text font-mono text-[11px] leading-none text-white/40 ${className}`}
    >
      v{semver}
    </span>
  );
}
